<template>
    <BlockConfig title="Checklist"
        :valid="valid"
        @handleSave="handleSave"
        @restore="restore">
        <v-form v-model="valid">
            <div class="d-flex my-2">
            <v-text-field dense outlined
                label="nome prova*"
                :rules="[rules.mandatory]" 
                v-model="config_data.title"
            ></v-text-field>
            </div>
            <div class="d-flex my-2">
                <v-text-field dense outlined
                    label="traduzione inglese"
                    v-model="config_data.translation"
                ></v-text-field>
            </div>
            <div class="d-flex flex-grow-1 flex-shrink-0 justify-end mb-2">
                <v-btn @click="addRow"><v-icon>add_box</v-icon>check</v-btn>
            </div>
                <div class="d-flex flex-column ml-4 flex-grow-1 flex-shrink-0">
                    <div v-for="(item, index) in config_data.items" :key="index">
                        <v-container class="mx-0 px-0">
                            <v-row no-gutters class="align-baseline justify-end">
                            <v-col class="text-right" cols="1">{{ (index+1) }}</v-col>                            
                            <v-col cols="9">
                                <v-text-field dense outlined
                                    class="ml-4"
                                    hide-details
                                    v-model="item.label"
                                    :rules="[rules.mandatory]"
                                ></v-text-field>
                            </v-col>
                            <v-col class="text-right justify-end" cols="2"><v-icon @click="removeCheck(index)">delete</v-icon></v-col>
                            </v-row>
                        </v-container>
                    </div>
                </div>
        </v-form>
    </BlockConfig>
</template>
<script>
import {ConfigMixin} from '../../../utils/configMixin_new'
import BlockConfig from '../../../components/utils/BlockConfig'

export default {
    components: {BlockConfig},
    mixins: [ConfigMixin],
    // props: ['data'],
    data(){
        return {
            o_data:{
                title: this.data.block.label,
                translation: "",
                items:[]
            }
        }
    },
    methods: {
        addRow(){
            this.config_data.items.push({label: ""})
        },
        removeCheck(index) {
            this.config_data.items.splice(index,1)
        }
    },
}
</script>